import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import { FaShare, FaStar } from "react-icons/fa6";
import './SuccessPage.css';
import axios from 'axios';

function SuccessPage() {
  const { slug } = useParams();
  const [shareLink, setShareLink] = useState('https://www.indeed.com/');

  useEffect(() => {
    if (!slug) return; // Optionally guard against undefined/null
  
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/clients.php?slug=${slug}`;
  
    axios.get(url)
      .then((response) => {
        const data = response.data;
        setShareLink(data.share_link || '');
      })
      .catch((error) => {
        console.error("Error fetching account details!", error);
      });
  });
  

  // parse query params
  const searchParams = new URLSearchParams(window.location.search);
  const sentiment = searchParams.get('sentiment') || '';
  const feedbackText = searchParams.get('feedback') || '';
  const name = searchParams.get('name') || '';
  const aiTitle = searchParams.get('title') || '';

  return (
    <div className="success-page-container">
      <h1>Thank You for Your Feedback!</h1>
      <p>Your feedback has been submitted successfully.</p>

      {/* Show Indeed share link only if sentiment is positive */}
      {sentiment.toLowerCase() === 'positive' && (
        <div className="share-container">
            <div className='share-container-horizontal'>
                <div className='share-container-left'>
                    <p>Your Feedback Matters – Make your voice heard and inspire others by leaving your review on:</p>
                    <img src="../../Indeed_logo.png" alt='Indeed logo'/>
                </div>
                <div className='share-container-right'>
                    <div style={{ marginBottom: '0.5em', display: 'flex', alignItems: 'center' }}>
                      <h2>5.0</h2>
                      <FaStar style={{ color: '#FFD700', fontSize: '1.5em', marginRight: '4px' }} />
                      <FaStar style={{ color: '#FFD700', fontSize: '1.5em', marginRight: '4px' }} />
                      <FaStar style={{ color: '#FFD700', fontSize: '1.5em', marginRight: '4px' }} />
                      <FaStar style={{ color: '#FFD700', fontSize: '1.5em', marginRight: '4px' }} />
                      <FaStar style={{ color: '#FFD700', fontSize: '1.5em' }} />
                    </div>
                    <h1>{aiTitle}</h1>
                    <p className='feedback-name'>{name} {new Date().toLocaleDateString()}</p>
                    <p>{feedbackText}</p>
                </div>
            </div>
          <a
            href={shareLink}
            target="_blank"
            rel="noopener noreferrer"
            className="share-button"
          >
            <FaShare />
            Share
          </a>
        </div>
      )}
    </div>
  );
}

export default SuccessPage;
